import { HttpClient } from '@angular/common/http';
import { ExtraOptions } from '@angular/router';
import { ToastConfig } from '@ngxpert/hot-toast';
import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IConfig } from 'ngx-mask';

export const TOAST_CONFIG: Partial<ToastConfig> = {
  duration: 10_000,
  dismissible: true,
  visibleToasts: 1,
  loading: {
    autoClose: false,
    dismissible: false,
  },
};

export const TRANSLATE_CONFIG: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
    deps: [HttpClient],
  },
  defaultLanguage:
    JSON.parse(localStorage.getItem('lang') || '{}')?.value || 'es',
};

export const MASK_CONFIG: Partial<IConfig> = {
  allowNegativeNumbers: false,
  validation: false,
};

export const ROUTER_CONFIG: ExtraOptions = {
  useHash: true,
  anchorScrolling: 'enabled',
  initialNavigation: 'enabledBlocking',
};
